export default {"src":"/_next/static/media/awards-circular.9e0cac87.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};